import { Component, Input, OnInit } from '@angular/core';
import { RecursivePartial } from '@models/apollo';
import { Order } from '@queries/generated';
import { EcommerceTrackingService } from '@services/ecommerce-tracking.service';
import { OrdersService } from '@services/orders.service';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { SidebarToggleComponent } from '../sidebar-toggle/sidebar-toggle.component';

@Component({
  selector: 'vnm-checkout-receipt',
  templateUrl: './checkout-receipt.component.html',
  styleUrls: ['./checkout-receipt.component.scss']
})
export class CheckoutReceiptComponent implements OnInit {
  @Input() orderId!: number;

  order$: Observable<RecursivePartial<Order>>;

  constructor(
    private orders: OrdersService,
    private ecom: EcommerceTrackingService,
    private sidebarToggle: SidebarToggleComponent
  ) {}

  ngOnInit() {
    this.order$ = this.orders.findById(this.orderId).pipe(tap((order) => this.ecom.purchase(order)));
  }

  onViewReceipt() {
    this.sidebarToggle?.close();
  }
}
